import {Component, OnInit, ViewChild, ElementRef, HostBinding, Input} from '@angular/core';
import * as pbi from 'powerbi-client';
import {HttpService} from 'app/core/services/http.service';
import {environment as env} from 'environments/environment';
import {SnackbarService, SettingsProvider} from 'app/core';
import {map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

interface ReportFetchModel {
    embedObject: ReportModelResponse;
    name: string;
}

interface ReportModelResponse {
    reportId: string;
    embedUrl: string;
    token: {
        token: string
        tokenId: string
        expiration: string
    };
}

@Component({
    selector: 'pbi-report',
    templateUrl: './pbi-report.component.html',
    styleUrls: []
})
export class PbiReportComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @ViewChild('repdiv', {static: true}) div: ElementRef;

    @Input()
    public name: string;

    private token: string;
    private reportId: string;
    private embedUrl: string;
    isLoadingResults = false;

    constructor(private http: HttpService,
                private snackBar: SnackbarService,
                private serviceSettings: SettingsProvider) {
    }

    ngOnInit() {
        const url = `${this.serviceSettings.configuration.url}${env.RaportsService.apiUrlGet}?name=${encodeURIComponent(this.name)}`;

        this.isLoadingResults = true;
        this.http.get(url)
            .pipe(
                map((data: ReportFetchModel) => {
                    this.token = data.embedObject.token.token;
                    this.reportId = data.embedObject.reportId;
                    this.embedUrl = data.embedObject.embedUrl;
                }),
                mergeMap(() => of(this.render()))
            )
            .subscribe(
                null,

                err => {
                    this.isLoadingResults = false;
                    console.log(err);
                    if (err.status !== 403) {
                        this.snackBar.info('Wystąpił błąd podczas ładowania raportu.');
                    }
                }
            );
    }

    public render() {
        const embedUrl = this.embedUrl;
        const embedReportId = this.reportId;
        const config: pbi.IEmbedConfiguration = {
            type: 'report',
            tokenType: pbi.models.TokenType.Embed,
            accessToken: this.token,
            embedUrl: embedUrl,
            id: embedReportId,
            settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: true
            }
        };
        const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        // delete loading results
        this.isLoadingResults = false;
        const report = powerbi.embed(this.div.nativeElement, config);
    }
}
